import type React from 'react';
import { useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';

import { Icon } from 'app/main/components';
import { toggleChatPanel } from './store/stateSlice';

interface ChatPanelToggleButtonProps {
	children?: React.ReactNode;
}

function ChatPanelToggleButton({ children = <Icon icon="chat" /> }: ChatPanelToggleButtonProps) {
	const dispatch = useDispatch();

	return (
		<IconButton color="inherit" className="h-40 w-40" onClick={ev => dispatch(toggleChatPanel())}>
			{children}
		</IconButton>
	);
}

export default ChatPanelToggleButton;
